
export default class Flashmsgs {

    static init() {
        const flashmsgs = document.querySelectorAll('.flash-messages .alert');

        if (flashmsgs.length > 0) {
            flashmsgs.forEach(msg => {
                const closer = msg.querySelector('button');
                if (closer) {
                    closer.addEventListener('click', (e) => {
                        e.preventDefault();
                        msg.classList.add('flash-messages--fade-out');
                        setTimeout(() => {
                            msg.style.display = 'none';
                        },250);
                    })
                }
                // --- Auto fade out
                const hasAlertLongClass = Array.from(msg.classList).some(className => className.includes('alert-long'));

                if(!hasAlertLongClass) {
                    setTimeout(() => {
                        msg.classList.add('flash-messages--fade-out');
                    }, 3000);
                    setTimeout(() => {
                        msg.style.display = 'none';
                    }, 3250);
                }
            });
        }
    }
}
